module.exports = __webpack_public_path__ + "images/Zscaler-8511b0.png";